import { Button } from "azure-devops-ui/Button";
import { OverflowButton, ResizeGroup } from "azure-devops-ui/ResizeGroup";
import { Splitter, SplitterDirection, SplitterElementPosition } from "azure-devops-ui/Splitter";
import { Tooltip } from "azure-devops-ui/TooltipEx";
import * as React from "react";

export default class ResizeGroupExample extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const containerStyle = { height: "300px", width: "100%" };
        return (
            <div style={containerStyle}>
                <Splitter
                    fixedElement={SplitterElementPosition.Near}
                    splitterDirection={SplitterDirection.Vertical}
                    onRenderNearElement={this.renderResizeGroup}
                    onRenderFarElement={() => <div style={{width: "100%", height: "300px"}} />}
                    ariaLabel="separator"
                />
            </div>
        );
    }

    public renderResizeGroup() {
        const responsiveLayoutProps = { ignoredChildren: [5], responsiveChildren: [2, 3, 6] };
        const overflowMenuItems = [
            { id: "item-1", text: "Hideable Button" },
            { id: "item-2", text: "Hideable Text" },
            { id: "item-3", text: "Hideable Button 2" }
        ];
        return (
            <div className="flex-column flex-grow scroll-hidden" style={{ margin: "8px" }}>
                <div className="flex-row flex-start scroll-hidden">
                    <ResizeGroup
                        responsiveLayoutProps={responsiveLayoutProps}
                        overflowMenuItems={overflowMenuItems}
                    >
                        <div
                            className="flex-row flex-center flex-grow flex-wrap scroll-hidden"
                            style={{ whiteSpace: "nowrap" }}
                        >
                            <OverflowButton key="item1" />
                            <div key="item2" style={{ marginRight: "4px" }}>
                                <Button>Test Button</Button>
                            </div>
                            <div key="item3" style={{ marginRight: "4px" }}>
                                <Button>Hideable Button</Button>
                            </div>
                            <span key="item4">Hideable Text</span>
                            <Tooltip key="item5" overflowOnly>
                                <pre key="item5" className="fontWeightSemiBold font-weight-semibold text-ellipsis">
                                    {" "}
                                    Text element{" "}
                                </pre>
                            </Tooltip>
                            <div key="item6" className="flex-grow" />
                            <Button key="item7">Hideable Button 2</Button>
                        </div>
                    </ResizeGroup>
                </div>
            </div>
        );
    }
}
